"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = require("@mui/base/Button");
require("./HCard.scss");
const style = __importStar(require("./HCard.scss.json"));
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
const ImageView_1 = require("lincd-schema/lib/components/ImageView");
const LinkedFileStorage_1 = require("lincd/lib/utils/LinkedFileStorage");
function HCard({ name, buttonText, bottomSection, description, image, onClick, }) {
    return (react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(style.MainCard, bottomSection && style.withFooter), onClick: onClick },
        react_1.default.createElement("div", { className: style.Card },
            react_1.default.createElement("div", { className: style.CardImage },
                react_1.default.createElement(ImageView_1.ImageView, { of: image })),
            react_1.default.createElement("div", { className: style.HCardContent },
                react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(style.HCardDescription, description && style.withDescription) },
                    react_1.default.createElement("h3", null, name),
                    description ? react_1.default.createElement("p", null, description) : null),
                react_1.default.createElement(Button_1.Button, { className: style.HCardButton },
                    react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/icons/ArrowIcon.svg'), alt: "Card Button" }),
                    buttonText ? react_1.default.createElement("p", null, buttonText) : null))),
        bottomSection ? react_1.default.createElement(BottomSection, null) : null));
}
const BottomSection = () => {
    const [isCompleted, setIsCompleted] = (0, react_1.useState)(false);
    return (react_1.default.createElement("div", { className: style.BottomSection, onClick: () => setIsCompleted((prevState) => !prevState) }, isCompleted ? (react_1.default.createElement("div", { className: style.Completed },
        react_1.default.createElement("div", { className: style.StatusSection },
            react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/icons/MdCheckCircleOutline.svg'), alt: "Button Icon", width: "28px" }),
            react_1.default.createElement("p", null, "Completed")),
        react_1.default.createElement("div", { className: style.EditSection },
            react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/icons/MdEditIcon.svg'), alt: "Button Icon", width: "18px" }),
            react_1.default.createElement("p", null, "Edit")))) : (react_1.default.createElement("div", { className: style.Complete },
        react_1.default.createElement("img", { src: (0, LinkedFileStorage_1.asset)('/images/icons/MdCheckCircleOutline.svg'), alt: "Button Icon", width: "22px" }),
        react_1.default.createElement("p", null, "Complete")))));
};
exports.default = HCard;
//# sourceMappingURL=HCard.js.map